module.exports = __webpack_public_path__ + "img/[囧].170b188c.svg";